export function getInitialPrefetchTagTypes(readonly = false) {
  if (readonly) {
    return [];
  }

  return ['FAULT_PHENOMENON', 'SYSTEM_VOLTAGE'];
}
